import { render } from "./EditTemplate.vue?vue&type=template&id=506d6b02&scoped=true&ts=true"
import script from "./EditTemplate.vue?vue&type=script&lang=ts"
export * from "./EditTemplate.vue?vue&type=script&lang=ts"

import "./EditTemplate.vue?vue&type=style&index=0&id=506d6b02&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506d6b02"]])

export default __exports__